import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionUpdateActions } from './hooks/usePetitionUpdateActions';

export const PetitionUpdateActions: React.FC<EmptyProps> = () => {
	const {
		data: { canEdit, editUrl, confirmModal },
		actions: { deletePetitionUpdate },
	} = usePetitionUpdateActions();

	if (!canEdit) return null;

	return (
		<div className="flex flex-row gap-2">
			<Button variant="secondary" size="x-small" as="a" href={editUrl} data-qa="edit-update-button">
				<Translate value="fe.pages.petition_update.edit" />
			</Button>
			<Button
				variant="secondary"
				size="x-small"
				onClick={deletePetitionUpdate}
				data-testid="delete-petition-update"
				data-qa="delete-update-button"
			>
				<Translate value="fe.pages.petition_update.delete" />
			</Button>
			{confirmModal}
		</div>
	);
};
